import { render, staticRenderFns } from "./PaymentAmountPopup.vue?vue&type=template&id=400b4421&scoped=true&"
import script from "./PaymentAmountPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentAmountPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400b4421",
  null
  
)

export default component.exports